import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=4512ec4d&scoped=true&"
import script from "./Translations.vue?vue&type=script&lang=js&"
export * from "./Translations.vue?vue&type=script&lang=js&"
import style0 from "./Translations.vue?vue&type=style&index=0&id=4512ec4d&lang=scss&scoped=true&"
import style1 from "./Translations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4512ec4d",
  null
  
)

export default component.exports